import { Component, Input, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { PeripheralTopicItemModel } from 'src/app/model/shared/components/peripheral-topic-item';

@Component({
  selector: 'app-peripheral-topic-item',
  templateUrl: './peripheral-topic-item.component.html',
  styleUrls: ['./peripheral-topic-item.component.scss']
})
export class PeripheralTopicItemComponent implements OnInit {

  @Input() content: PeripheralTopicItemModel;

  @Output() blockClick = new Subject<PeripheralTopicItemModel>();

  readonly MESSAGES = Messages;

  constructor() { }

  ngOnInit(): void { }

  /**
   * Determines whether block click on
   * @param selectedBlock
   */
  onBlockClick(selectedBlock: PeripheralTopicItemModel) {
    this.blockClick.next(selectedBlock);
  }
}
